module.exports = __webpack_public_path__ + "static/mochi-5dee2a9248a21d4704adb43156114217.jpg";